import { ConversationStatus, Message } from 'apps/aiAutomation/components/Playground/types'

export enum ConversationEndReason {
  ACHIEVED = 'achieved',
  OPERATOR_REQUESTED = 'operator_requested',
}

export interface LeadQualPlaygroundState {
  goalId: string | null
  sessionId: string | null
  status: ConversationStatus
  endReason: ConversationEndReason | null
  typingMessageBuffer: Message | null
  messages: Message[]
}

export const LeadQualPlaygroundInitialState: LeadQualPlaygroundState = {
  goalId: null,
  sessionId: null,
  status: ConversationStatus.IDLE,
  endReason: null,
  messages: [],
  typingMessageBuffer: null,
}
